const toBoolean = (value) => typeof value === 'string' && value.trim().toLowerCase() === 'true';

export const SHOW_ZELLO_SECTIONS = toBoolean(process.env.REACT_APP_SHOW_ZELLO_SECTIONS);
